import {
  computed,
  ref,
  toRef,
} from "vue";

export default function InfoHeaderAPI(props) {
  const infoHeader = toRef(props, "infoHeader");
  const infoHeaderSlot = toRef(props, "infoHeaderSlot");
  const infoHeaderTitle = toRef(props, "infoHeaderTitle");

  const statusShowInfoHeader = ref(false);

  const infoHeaderAlertVisible = computed(() => {
    return infoHeader.value ||
      infoHeaderSlot.value;
  });

  const infoHeaderVisible = computed(() => {
    return infoHeaderAlertVisible.value ||
      infoHeaderTitle.value;
  });

  const toggleStatusShowInfoHeader = () => {
    statusShowInfoHeader.value = !statusShowInfoHeader.value;
  };

  return {
    infoHeaderAlertVisible,
    infoHeaderVisible,
    statusShowInfoHeader,
    toggleStatusShowInfoHeader,
  };
}
